import React from "react";
import { useState } from "react";

export const VideoPlayer = (props) => {
  const [showVideo, setShowVideo] = useState(false);

  const handleClick = () => {
    setShowVideo(() => !showVideo);
  };

  const workMarkup = (link) => {
    return { __html: link.embeddedVideo };
  };

  /* CSS */
  // const buttonCss = {
  //   fontfamily: "Open Sans",
  //   font-size: 16px,
  //   letter-spacing: 2px,
  //   text-decoration: none;
  //   text-transform: uppercase;
  //   color: #000;
  //   cursor: pointer;
  //   border: 3px solid;
  //   padding: 0.25em 0.5em;
  //   box-shadow: 1px 1px 0px 0px, 2px 2px 0px 0px, 3px 3px 0px 0px, 4px 4px 0px 0px, 5px 5px 0px 0px;
  //   position: relative;
  //   user-select: none;
  //   -webkit-user-select: none;
  //   touch-action: manipulation;
  // }

  const buttonCss = {
    fontFamily: "var(--font-base)",
    fontSize: 16,
    letterSpacing: 2,
    textDecoration: "none",
    textTransform: "uppercase",
    color: "#E86A92",
    cursor: "pointer",
    border: "2px solid",
    padding: "0.25em 0.5em",
    boxShadow:
      "1px 1px 0px 0px, 2px 2px 0px 0px, 3px 3px 0px 0px, 4px 4px 0px 0px, 5px 5px 0px 0px",
    position: "relative",
    userSelect: "none",
    touchAction: "manipulation",
    margin: "0.5rem",
  };

  // .button-54:active {
  //   box-shadow: 0px 0px 0px 0px;
  //   top: 5px;
  //   left: 5px;
  // }

  return (
    <div>
      <button style={buttonCss} onClick={handleClick}>
        {showVideo ? "Hide Video" : "Show Video"}
      </button>
      {showVideo && (
        <div
          className="app__work-playback"
          dangerouslySetInnerHTML={workMarkup(props.work)}
        ></div>
      )}
    </div>
  );
};
